// packages
import { Fragment } from 'react';
import Helmet from 'react-helmet';
// components
import MainLP from '../../components/Layout/Main/Main';
import img from '../../assets/images/slider-home-inner.jpg';
// api

// styles
import './Home.scss';
const Home = () => {
  const dummy_course = [
    {
      img: './PSOCC.jpg',
      title: 'Public Safety Officers Candidate Course (PSOCC)',
      participants: '300',
    },
    { img: './PSSLC.jpg', title: 'Public Safety Senior Leadership Course (PSSLC)', participants: '50' },
    { img: './PSJLC.jpg', title: 'Public Safety Junior Leadership Course (PSJLC)', participants: '50' },
    { img: './PSBRC.jpg', title: 'Public Safety Officers Candidate Course (PSOCC)', participants: '50' },
  ];
  return (
    <Fragment>
      <Helmet>
        <title>Home</title>
      </Helmet>
      <MainLP>
        <section className='header_home'>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-6 mb-3'>
                <div className='header-text'>
                  <p className='h1'>Philippine National Police Training Institute</p>
                  <p className='h3'>Learning Management System</p>
                  <p className='h6'>Center for development of new generation policing.</p>
                  <br />
                  <button className='btn px-3 py-3'>
                    Log In Now! <span className='ms-3'>{'>'}</span>
                  </button>
                </div>
              </div>
              <div className='col-lg-6 mb-3'>
                <img
                  alt='img'
                  src={img}
                  className='img-fluid'
                />
              </div>
            </div>
          </div>
        </section>
        <section className='courses'>
          <h2 className='text-center '>COURSES</h2>
          <div className='container'>
            <div className='row'>
              {dummy_course.map((courses) => {
                return (
                  <div className='col-lg-6 col-12 mb-5'>
                    <div className='courses-card'>
                      <img
                        className='img-fluid'
                        alt='img'
                        src={courses.img}
                      />
                      <div className='card-text'>
                        <p className='title'>{courses.title}</p>
                        <p className='participants'>Number of Participants:{courses.participants}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      </MainLP>
    </Fragment>
  );
};

export default Home;
